export const BYDA_MEMBER_LOOKUP_SUPPORT_EMAIL = 'support@byda.com.au';

export const LOOKUP_TIMEOUT_ERROR = 'LOOKUP_TIMEOUT:';

export const FILE_VALIDATION_FAILED_PREFIX = 'FILE_VALIDATION_FAILED:';

export const FILE_VALIDATION_TIMEOUT_PREFIX = 'FILE_VALIDATION_TIMEOUT:';

export const LOOKUP_TIMEOUT_TITLE =
  'Your lookup is taking longer than expected';

export const LOOKUP_TIMEOUT_SUBTITLE =
  'You can leave this page while we finish preparing your results. We’ll email you when they’re ready.';

export const LOOKUP_TIMEOUT_SUPPORT_LINE = `If you need help, contact ${BYDA_MEMBER_LOOKUP_SUPPORT_EMAIL}`;

export const FILE_VALIDATION_FAILED_TITLE = 'File validation failed';

export const FILE_VALIDATION_TIMEOUT_TITLE =
  'Your file is taking longer than expected';

export function formatUserFacingErrorCode(errorCode: number | string): string {
  return ` (Error code: ${errorCode})`;
}

function formatDetailSentence(detail?: string): string {
  if (!detail?.trim()) {
    return '';
  }
  const trimmed = detail.trim().replace(/\.$/, '');
  return `${trimmed}. `;
}

export function formatFileValidationFailedMessage(
  detail?: string,
  idSuffix = ''
): string {
  return `${FILE_VALIDATION_FAILED_PREFIX}${formatDetailSentence(
    detail
  )}Please try again or contact ${BYDA_MEMBER_LOOKUP_SUPPORT_EMAIL}.${idSuffix}`;
}

export function formatFileValidationTimeoutMessage(idSuffix = ''): string {
  return `${FILE_VALIDATION_TIMEOUT_PREFIX}File validation is still in progress. Please try again later or contact ${BYDA_MEMBER_LOOKUP_SUPPORT_EMAIL} if the issue persists.${idSuffix}`;
}

export function formatNoValidShapesMessage(): string {
  return formatFileValidationFailedMessage(
    'No valid shapes were found in your file'
  );
}

type UploadErrorNotification = {
  title: string;
  subtitle: string;
  kind: 'error' | 'warning';
};

export function parseMemberLookupUploadError(
  error: string | null
): UploadErrorNotification | null {
  if (!error) {
    return null;
  }

  if (error.startsWith(FILE_VALIDATION_FAILED_PREFIX)) {
    return {
      title: FILE_VALIDATION_FAILED_TITLE,
      subtitle: error.slice(FILE_VALIDATION_FAILED_PREFIX.length).trim(),
      kind: 'error'
    };
  }

  if (error.startsWith(FILE_VALIDATION_TIMEOUT_PREFIX)) {
    return {
      title: FILE_VALIDATION_TIMEOUT_TITLE,
      subtitle: error.slice(FILE_VALIDATION_TIMEOUT_PREFIX.length).trim(),
      kind: 'warning'
    };
  }

  return {
    title: 'Upload failed',
    subtitle: error,
    kind: 'error'
  };
}
